import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'

const ReviewInstitutionalAccount = ({ template, handleRetirementAccountReview }) => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        {template.sponsorName} added your current retirement plan information. Please review and
        complete any missing data.&nbsp;
        <Section.Link onClick={handleRetirementAccountReview}>Review account</Section.Link>
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default ReviewInstitutionalAccount
